import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './assets/tailwind.css';
import './assets/tech-background.css';
import i18n from './i18n';
import { removeToken, getToken } from './api/http';
import { useUserStore } from './stores/user';
// 改为按需导入Element Plus
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css' // 保留样式导入
import '@fortawesome/fontawesome-free/css/all.min.css';

// 创建pinia存储
const pinia = createPinia();

// 创建Vue应用实例
const app = createApp(App);

// 使用插件
app.use(pinia);
app.use(router);
app.use(i18n);
// 移除全局ElementPlus注册
// app.use(ElementPlus)

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 挂载应用
app.mount('#app');

// 添加跨窗口token共享支持
window.addEventListener('message', (event) => {
  try {
    const data = event.data;
    if (data && data.type === 'SAVE_TOKEN') {
      console.log('收到token共享消息:', data.key);
      localStorage.setItem(data.key, data.value);
      sessionStorage.setItem(data.key, data.value);
    }
  } catch (e) {
    console.error('处理窗口消息失败:', e);
  }
});

// 添加对localStorage变化的监听，实现多窗口同步
window.addEventListener('storage', (event) => {
  // 监听重要的键变化
  if (event.key === 'token' || event.key === 'user' || event.key === 'img_task' || event.key === 'video_task' || event.key === 'order') {
    console.log(`检测到存储变化: ${event.key}`);
    
    // 如果是在当前窗口删除了token，但在其他窗口存在，则重新获取
    if (event.newValue && !localStorage.getItem(event.key)) {
      localStorage.setItem(event.key, event.newValue);
    }
    
    // 刷新页面以应用最新状态
    if (event.key === 'token') {
      if (!event.newValue && getToken()) {
        // 其他窗口登出，当前窗口也需要登出
        removeToken();
        useUserStore().clearUserState();
        window.location.reload();
      } else if (event.newValue && !getToken()) {
        // 其他窗口登录，当前窗口也需要登录
        window.location.reload();
      }
    }
  }
}); 